import { FC } from "react";
import { GiftIcon } from "shared/ui/icons";
import { WheelRafflesButton } from "./WheelRafflesButton";

interface Props {
  className?: string;
}

// Иконка в боковой панели: розыгрыши доступны всем, создание — по праву.
export const WheelRafflesNavButton: FC<Props> = ({ className }) => (
  <WheelRafflesButton className={className} title="Promos" restoresList>
    <GiftIcon />
  </WheelRafflesButton>
);
